import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import { SOURCE_URL } from '../../../config';
import language from '../../../utils/LanguageSettings';
import { useAppDispatch, useAppSelector } from '../../../stores/hook';
import { setSwiperAutoPlay, setTncShow, setTncText, setVideoShow, setVideoUrl } from '../GetStarted/GetStartedSlice';
import HomeBannerText from './HomeBannerText';
import { setImageHeightsForHomePage } from '../../functions/ResetHeight';


interface HomeBannerProps {
    element: any[];
}

SwiperCore.use([Autoplay, Pagination]);

const isTouchOrCoarsePointer = () => {
  if (typeof window === 'undefined') return false;
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches
  );
};

const HomeBanner: React.FC<HomeBannerProps> = ({ element }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const swiperRef = useRef<any>(null);
  const autoplayRef = useRef(null);
  const swiperAutoPlay = useAppSelector((state) => state.getStarted.swiperAutoPlay);
  const dispatch = useAppDispatch();

  useEffect(()=>{
    if (!swiperRef.current) return;
    const swiperInstance = swiperRef.current.swiper;
    if(swiperAutoPlay){
      swiperInstance.autoplay.start();
    }else{
      swiperInstance.autoplay.stop();
    }
  },[swiperAutoPlay])

  const clickTnc = (tncText: any) => {
    dispatch(setSwiperAutoPlay(false));
    dispatch(setTncShow(true));
    dispatch(setTncText(tncText));
  }

  function clickVideo(videoUrl: string) {
    dispatch(setSwiperAutoPlay(false));
    dispatch(setVideoShow(true));
    dispatch(setVideoUrl(videoUrl));
  }

  const handleSlideChange = (swiper) => {
    setCurrentSlide(swiper.realIndex)
    setImageHeightsForHomePage();
    if(document.getElementsByTagName("iframe")[0] != null){
      const iframeSrc = document.getElementsByTagName("iframe")[0].src;
      document.getElementsByTagName("iframe")[0].src = '';
      document.getElementsByTagName("iframe")[0].src = iframeSrc;
    }
  };

  useEffect(()=> {
      setImageHeightsForHomePage();
  },[element,language]);

  useEffect(() => {
      window.addEventListener('resize', setImageHeightsForHomePage);
      return () => {
        window.removeEventListener('resize', setImageHeightsForHomePage);
      };
    }, []);

  const handlePointerDown = (e: React.PointerEvent) => {
    if (!swiperRef.current?.swiper) return;
    const swiperInstance = swiperRef.current.swiper;
    if (e.pointerType === 'touch') {
      swiperInstance.params.noSwiping = false;
    } else if (e.pointerType === 'mouse') {
      swiperInstance.params.noSwiping = true;
    }
  };

  return (
    <div
      className="carousel-container"
      onPointerDownCapture={handlePointerDown}
      onTouchStartCapture={() => {
        if (swiperRef.current?.swiper) {
          swiperRef.current.swiper.params.noSwiping = false;
        }
      }}
    >
      <style>{`.carousel-container .swiper-pagination-bullet{background: transparent;position: relative;border: 2px solid #fff;width: 8px;height: 8px;opacity: 1;margin: 0 6px!important;} .carousel-container .swiper-pagination-bullet-active{border-color: #ef9528;}`}</style>
      <style>{`.swiper-pagination{width: 350px !important;margin: 0 auto !important;position: relative !important;bottom: 25px !important;} #sliding-banner .arrowed-link:hover{color: inherit !important}`}</style>
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, Pagination]}
        pagination={{
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active'
        }}
        autoplay={{
          delay: element[0]?.IntervalTime * 1000 || 5000,
          disableOnInteraction: false,
          waitForTransition: true,
          pauseOnMouseEnter:true,
          ref: (el) => (autoplayRef.current = el),
        }}
        loop={true}
        slidesPerView={1}
        className="custom-swiper"
        speed={500}
        noSwiping={!isTouchOrCoarsePointer()}
        onSlideChange={handleSlideChange}
      >
        {Array.isArray(element) && element.map((item, index) => (
          <SwiperSlide key={index}  data-swiper-autoplay={item.IntervalTime * 1000}>
            <li key={index} id={"slide-"+index} data-interval={item.IntervalTime} style={{minHeight: '450px'}} className={"object-item "+item?.TextColor?.toLowerCase()} data-imgposition={item?.ImagePosition?.replace(" - ", " ").toLowerCase()} data-imgpositiontab={item?.ImagePositionTablet?.replace(" - ", " ").toLowerCase()} data-imgpositionmob={item?.ImagePositionMobile?.replace(" - ", " ").toLowerCase()}>
                    {item?.Image?.data?.attributes?.url ? 
                    <>
                    <img src={SOURCE_URL + item?.Image?.data?.attributes?.url} className='object-desktop-image w-100 main-img img-fit d-xl-block d-none' style={{objectPosition: item?.ImagePosition?.replace(" - ", " ").toLowerCase()}}/>
					          <img src={SOURCE_URL + item?.ImageTablet?.data?.attributes?.url} className='object-tab-image w-100 main-img img-fit d-xl-none d-lg-block d-none' style={{objectPosition: item?.ImagePositionTablet?.replace(" - ", " ").toLowerCase()}}/>
					          <img src={SOURCE_URL + item?.ImageMobile?.data?.attributes?.url} className='object-mobile-image w-100 main-img img-fit d-lg-none d-block' style={{objectPosition: item?.ImagePositionMobile?.replace(" - ", " ").toLowerCase()}}/>
                    </>
                    : item?.YoutubeVideoUrl ? 
                    <>
                    <div className={'video-wrap '+ (item?.BannerText || item?.Button?.URL ? "" : "row no-gutters align-items-center")}>
                      <div className={'video-responsive position-relative '+ (item?.BannerText || item?.Button?.URL ? "" : "col")}>
                        {item?.VideoOption == 'Autoplay with no sound' ? 
                        <iframe className='w-100 h-100' src={item?.YoutubeVideoUrl.indexOf("?") > -1 ? item?.YoutubeVideoUrl + "&autoplay=1&rel=0&showinfo=0&modestbranding=1&loop=1&modestbranding=1&mute=1&enablejsapi=1" : item?.YoutubeVideoUrl + "?autoplay=1&rel=0&showinfo=0&modestbranding=1&loop=1&modestbranding=1&mute=1&enablejsapi=1"} frameBorder='0'></iframe>
                        :
                        <iframe className='w-100 h-100' src={item?.YoutubeVideoUrl.indexOf("?") > -1 ? item?.YoutubeVideoUrl + "&rel=0&showinfo=0&modestbranding=1&loop=1&enablejsapi=1" : item?.YoutubeVideoUrl + "?rel=0&showinfo=0&modestbranding=1&loop=1&enablejsapi=1"} frameBorder='0'></iframe>}
                      </div>
                    </div>
                    </>
                    :<></>}
                    {(item?.BannerText || item?.Button?.URL || item?.Html5Video?.data) ?
                    <div className={"caption-text py-5 "+item?.BannerTextPosition?.toLowerCase()+" "+item?.BannerTextVerticalAlignment?.toLowerCase()+" "+item?.TextColor?.toLowerCase()+" pxc"}>
                        <div>
                            <div className="to-be-calculated">
                                {item?.TitleArt?.data?.attributes?.url ?     
                                <img src={SOURCE_URL + item?.TitleArt?.data?.attributes?.url} className='img-fluid d-block title-art mb-3 pt-0'/>
                                : <></>}
                                <style>{`#sliding-banner li#slide-${index} .title-art {width: ${item?.WidthDesktop};height: ${item?.HeightDesktop};max-width:${item?.MaxWidthDesktop};max-height:${item?.MaxHeightDesktop};}@media(max-width: 991px){ #sliding-banner li#slide-${index} .title-art{width: ${item?.WidthMobile};height:${item?.HeightMobile};max-width: ${item?.MaxWidthMobile};max-height:${item?.MaxHeightMobile}}}`}</style>
                                <HomeBannerText bannerText={item?.BannerText} lang={language} currentSlide={currentSlide}/>
                                {item?.DesktopChannelLogo?.data?.attributes?.url ? <img src={SOURCE_URL + item?.DesktopChannelLogo?.data?.attributes?.url}  className='img-fluid d-lg-block d-none'/> : <></>}
                                {item?.MobileChannelLogo?.data?.attributes?.url ? <img src={SOURCE_URL + item?.MobileChannelLogo?.data?.attributes?.url}  className='img-fluid d-lg-none d-block'/> : <></>}
                                <div className='clearfix'></div>
                                {item?.Button?.URL ? 
                                <a href={item?.Button?.URL} target={item?.Button?.OpenLinkInANewTab ? '_blank' : '_self'} className='default-btn mt-4' id={item?.ButtonID}>{item?.Button?.LinkText}</a>
                                : item?.Html5Video?.data?.attributes?.url ? 
                                <a href='javascript:void(0);' className='default-btn mt-4' id={item?.ButtonID} onClick={()=>clickVideo(SOURCE_URL + item?.Html5Video?.data?.attributes?.url)}>{item?.Html5VideoButtonText}</a>
                                :<></>}
                                {item?.TcTitle == "See Terms & Conditions >" ? 
                                <>
                                <div className='clearfix'></div>
                                <a href='javascript:void(0);' data-src={'#tc-'+index} data-text={(language == 'en' ? "See Terms & Conditions" : "條款細則") +' >> '} className='arrowed-link swiper-no-swiping text-14 mt-3' style={{cursor:"pointer"}} onClick={() => clickTnc(item?.TcText)}>
                                  {language == 'en' ? "See Terms & Conditions" : "條款細則"}
                                  <i className='icon-angle-right'></i>
                                </a>
                                </>
                                :item?.TcTitle == "*Terms and conditions apply" ? 
                                <div style={{margin: "16px 0 0",fontSize: "14px"}}><small className="swiper-no-swiping">{language=="en" ? "*Terms and conditions apply" : "*受條款及條件約束"}</small></div>
                                :<></>}
                            </div>
                        </div>
                    </div>
                    :<></>}
                    {item?.BackgroundColorMobile != "" ?
                    <style>{`@media(max-width: 991px){ #sliding-banner li#slide-${index} .caption-text:before{content:'';background-color:${item?.BackgroundColorMobile};width:100%;height:100%;top:50%;left:0;position:absolute;z-index:-1;}#sliding-banner li#slide-${index} .caption-text{background: linear-gradient(180deg, transparent 0%, ${item?.BackgroundColorMobile} 15%, ${item?.BackgroundColorMobile} 20%, ${item?.BackgroundColorMobile} 40%, ${item?.BackgroundColorMobile} 100%) !important;}}`}</style>
                    :<></>
                    }
                </li>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeBanner;